import { Col } from "antd";
import { useMemo } from "react";
import Colors from "assets/Colors";
import { useTranslation } from "react-i18next";
import s from "../styles";
import { useBusinessContext } from "../../../../../BusinessApp";
import { currencyFormat } from "helpers/hooks";
import { useStockMasters } from "../../../../../graphql/useItems";

function Items({ item, itemVariant, prices, index, items, values }) {
  const { t } = useTranslation();
  const { storeId } = useBusinessContext();
  const { stockMasters } = useStockMasters(storeId);

  const priceItem = useMemo(
    () => items.find((_item) => _item._id === item.ownerId),
    [items, item.ownerId]
  );

  const formatVariantText = (variantItem) => {
    const formatText = (text) =>
      text
        .trim()
        .toLowerCase()
        .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));

    return `${formatText(variantItem.name)}: ${formatText(variantItem.value)}`;
  };

  const getPicksBasedOnBarcode = (barcode, itemVariant) => {
    if (!itemVariant || !barcode) return [];

    let rest = barcode;
    return itemVariant.variants.reduce((picks, variant) => {
      if (rest.length < variant.size) return picks;

      const segment = rest.substr(0, variant.size);
      const variantItem = variant.items.find((item) => item.value === segment);

      if (variantItem) {
        picks.push(variantItem);
      }
      rest = rest.substr(variant.size);
      return picks;
    }, []);
  };

  const picksMap = useMemo(() => {
    return stockMasters.reduce((result, stockMaster) => {
      result[stockMaster._id] = getPicksBasedOnBarcode(
        stockMaster.barcode,
        itemVariant
      );
      return result;
    }, {});
  }, [stockMasters, itemVariant]);

  const picksText = useMemo(() => {
    const variants = picksMap[item?._id] || [];
    return variants.length
      ? variants.map(formatVariantText).join(", ")
      : t("components.InventoryItems.AddItem.InventoryAdvanced.noFound");
  }, [picksMap, item?._id, t]);

  const itemPrice = prices[item?.barcode] || priceItem?.price || "N/A";

  return (
    <s.OptionRow style={{ background: index % 2 !== 0 && Colors.BG_MENU }}>
      <Col span={6}>
        <s.Text>
          {values?.barcode || ""} {item?.barcode || ""}
        </s.Text>
      </Col>
      <Col span={6}>
        <s.Text>{picksText}</s.Text>
      </Col>
      <Col span={6}>
        <s.Text>{currencyFormat(itemPrice)}</s.Text>
      </Col>
      <Col span={6}>
        <s.Text>{item?.quantity || "N/A"}</s.Text>
      </Col>
    </s.OptionRow>
  );
}

export default Items;
